import { path } from 'ramda';
import React from 'react';
import { EPromoSubscriptionType } from 'reactApp/modules/promoTariffs/promoTariffs.types';
import { ESubscriptionsTypes } from 'reactApp/modules/subscriptions/subscriptions.types';
import { IContent, ISubscriptionModalContent } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.types';
import { getPeriodName } from 'reactApp/utils/Period';

export const useContent = ({ subscription, product, partner }: ISubscriptionModalContent): IContent => {
    let header = <></>;
    const { type, space } = subscription;
    const isTrial = !!path(['isTrial'], subscription);
    const isPrepaid = !!path(['isPrepaid'], subscription);
    const base = path(['base'], subscription);
    const subsPeriod: any = (isTrial && product?.trialPeriod) || path(['period'], subscription) || product?.period;
    const period = subsPeriod && getPeriodName(subsPeriod, false, true);

    if (base) {
        header = <>Бесплатный объём Облака {space?.value}</>;
    } else if (product?.isForceDiscountTrial) {
        header = (
            <>
                + {space?.value} {period && `на\u00A0${getPeriodName(product?.period, false, true)}`}
            </>
        );
    } else {
        header = (
            <>
                {isTrial && !isPrepaid ? 'Триал' : ''} + {space?.value} {period && `на\u00A0${period}`}
            </>
        );
    }

    let warning = '';

    if (base || type === EPromoSubscriptionType.quota) {
        warning = 'Данная подписка не может быть изменена или отменена';
    }

    if (type === ESubscriptionsTypes.ios || type === ESubscriptionsTypes.android) {
        warning = `Данная подписка может быть изменена или отменена в ${type === ESubscriptionsTypes.ios ? 'AppStore' : 'Google Play'}`;
    }

    if (partner && Boolean(path(['accountLink'], subscription))) {
        warning = 'Управление тарифом доступно в личном кабинете';
    }

    return { header, warning };
};
